import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Modals from "../../../features/dataEntering/routes/dataEntering/components/Modals";
import { hideModal } from "../../redux/actions/modal";
import { RootState } from "../../redux/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MODAL_COMPONENTS: Record<string, React.ComponentType<any>> = {
    ASSIGNED_ACCOUNT_DETAIL: Modals.AssignedAccountDetailModal,
};

const ModalContainer = () => {
    const dispatch = useDispatch();
    const { modalType, modalProps } = useSelector((state: RootState) => state.modal);

    if (!modalType) {
        return null;
    }

    const SpecifiedModal = MODAL_COMPONENTS[modalType];

    if (!SpecifiedModal) {
        return null;
    }

    return <SpecifiedModal {...modalProps} hideModal={() => dispatch(hideModal())} />;
};

export default ModalContainer;
